<template>
  <div class="text-input">
    <ValidationProvider
      v-slot="{ errors }"
      :name="label"
      :rules="validationRules"
    >
      <div
        class="vs-component vs-con-input-label vs-input w-full vs-input-primary"
      >
        <div class="vs-con-input">
          <label
            v-if="label || required"
            :for="`input-${name}`"
            class="vs-input--label mb-1"
            >{{ label }}
            <span v-if="required" class="text-danger"
              ><feather-icon icon="star-of-life"/></span
          ></label>
          <vue-select
            :id="`input-${name}`"
            v-model="internalValue"
            v-bind="bindAttributes"
            class="w-full data-input"
            append-to-body
            :placeholder="placeholder"
            :label="selectLabel"
            :options="optionsArray"
            :name="name"
            :calculate-position="withPopper"
            :class="{ error: errors.length }"
          />
        </div>
      </div>
      <span v-show="errors.length" class="text-danger text-sm">{{
        errors[0]
      }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
import VueSelect from "vue-select";
import { createPopper } from "@popperjs/core";

export default {
  components: {
    VueSelect
  },
  props: {
    options: { type: [Array, Object], required: true },
    optionsType: { type: String, default: "string" },
    reduce: { type: Function, default: el => el.code },
    value: {
      type: [String, Number, Object, Array],
      default() {
        return null;
      }
    },
    validationRules: {
      type: [Object, String],
      default() {
        return null;
      }
    },
    selectLabel: { type: [String, Function], default: "label" },
    label: { type: String, default: null },
    placeholder: { type: String, default: null },
    name: { type: String, default: null },
    taggable: { type: Boolean, default: false },
    required: { type: Boolean, default: false }
  },
  computed: {
    bindAttributes() {
      let attrs = {
        ...this.$attrs
      };

      if (this.taggable) {
        attrs.taggable = true;
      } else {
        attrs.reduce = this.reduce;
      }

      return attrs;
    },
    optionsArray() {
      if (this.options instanceof Array) {
        return this.options;
      }

      const arr = [];
      Object.keys(this.options).forEach(code => {
        if (
          this.optionsType === "number" &&
          (code !== null || code !== undefined)
        ) {
          code = +code;
        }

        arr.push({ label: this.options[code], code });
      });

      return arr;
    },
    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width;

      const popper = createPopper(component.$refs.toggle, dropdownList, {
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1]
            }
          },
          {
            name: "toggleClass",
            enabled: true,
            phase: "write",
            fn({ state }) {
              component.$el.classList.toggle(
                "drop-up",
                state.placement === "top"
              );
            }
          }
        ]
      });

      return () => popper.destroy();
    }
  }
};
</script>

<style lang="scss">
.v-select.drop-up .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-style: none;
  border-bottom-style: solid;
  border-bottom-color: rgba(60, 60, 60, 0.26);
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
</style>
